import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { LoginService } from '../../../login-service'
@Component({
  selector: 'app-collabos',
  templateUrl: './collabos.component.html',
  // styleUrls: ['./collabos.component.scss'],
  providers: [LoginService]

})
export class CollabosComponent implements OnInit {
  inititaiorAdminType: string;
  collabosListDetails: any;
  collabosList: any
  userType: string;
  usertype: string;
  roleID: string;
  pager: {
    totalItems: number; currentPage: number; pageSize: number; totalPages: number; startPage: number;
    endPage: number; startIndex: number; endIndex: number;
    pages: number[];
  };
  searchWord: string = "";
  pagedItems: any;
  SearchList: any;

  currentpage: number = 1;

  searchText: any;
  view: boolean = false;
  collabodetails: any;
  tempProposalBids: any;
  collabobids: any;
  usersList: any;
  initiatordetails: any;
  count: any;
  opencollabos: any;
  opencount: any;
  tempbids = [];
  image: string;
  url: string;
  menuData: any;
  menuName: any;
  menuID: any;
  rolesList: any;
  MenuPermissions: any;
  userID: string;
  message: string;
  tabtype: any;
  selectedCollabosListid=[];
  dynamicRows: number;
  rowsOnPageSet: any[];
  rowCount: any;
  rowsOnPage: any;
  p:any;
  count1:any;
 savefilter: any;
  constructor(private loginService: LoginService) {
    this.roleID = localStorage.getItem("roleID");
    this.userID = localStorage.getItem("userID");
    this.inititaiorAdminType = localStorage.getItem('userTypeid');
  }

  ngOnInit(): void {
    this.loginService.getselectpage(10)
    this.GetCollabos();
    this.GetProposalBids();
    this.GetUsers();
    this.GetMenusByUserType(3);
    this.GetRoles();
  }
  GetRoles() {
    this.loginService.GetRoles(this.inititaiorAdminType).subscribe(data => {
      this.rolesList = JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
      let filteRole = this.rolesList.filter(x => x.RoleID.toString() == this.roleID.toString())

      if (filteRole.length > 0) {
        this.MenuPermissions = JSON.parse(filteRole[0].MenuJson);

      }
    });
  }
  GetMenusByUserType(userTypeID) {
    this.loginService.GetMenusByUserType(userTypeID).subscribe(data => {

      this.menuData = JSON.parse(JSON.stringify(JSON.parse(data['_body'])));

      let tempdata = this.menuData;

      this.menuData = tempdata.filter(x => x.menu_name.toString().toLowerCase() === 'collabos');

      if (this.menuData.length > 0) {
        this.menuName = this.menuData[0]["menu_name"];
        this.menuID = this.menuData[0]["menu_id"];
      }

    });
  }

  GetCollabos() {

    this.loginService.GetCollabos(this.inititaiorAdminType).subscribe(data => {
      this.collabosList = JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
      this.savefilter=this.collabosList
      this.collabosListDetails = this.collabosList;
      this.assigndynamicarray(this.collabosList)
      if (this.collabosListDetails.length > 0) {
        this.setPage(1);
      }

    })
  }
  assigndynamicarray(userslist)
  {
    this.dynamicRows=10
    this.rowsOnPageSet=[];
    this.rowCount = userslist.length;
    console.log(this.rowCount,this.dynamicRows)
    while (this.dynamicRows < this.rowCount) {
      this.rowsOnPageSet.push(this.dynamicRows);
      this.dynamicRows = this.dynamicRows + 10;
      console.log(this.rowsOnPageSet)
    }
    if (!this.rowsOnPageSet.includes(this.rowCount))
      this.rowsOnPageSet.push(this.rowCount);
    if (this.rowsOnPageSet.length === 1) {
      if (this.rowsOnPageSet[0] <= 10)
        this.rowsOnPage = this.rowsOnPageSet[0];
    }
    this.rowsOnPage = this.rowsOnPageSet[0];
  }
  GetProposalBids() {
    this.loginService.GetPraposalBids().subscribe(data => {
      this.tempProposalBids = JSON.parse(JSON.stringify(JSON.parse(data['_body'])));


    });
  }
  GetUsers() {
    this.loginService.GetUsers(this.inititaiorAdminType).subscribe(data => {
      this.usersList = JSON.parse(JSON.stringify(JSON.parse(data['_body'])));

    })
  }
  changepagination(page:number){
    this.count1=this.rowsOnPage
    console.log(this.rowsOnPage,this.p,this.count1);
    this.loginService.getselectpage(this.rowsOnPage)
    this.loginService.getPager(this.collabosListDetails.length, page);
    this.setPage(page)

  }
  setPage(page: number) {

this.p=page;
    this.pager = this.loginService.getPager(this.collabosListDetails.length, page);
    this.pagedItems = this.collabosListDetails.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.count1=this.pager.pageSize
    console.log(this.p,this.count1)
    this.collabosList = this.collabosListDetails.slice(this.pager.startIndex, this.pager.endIndex + 1);

  }

  Searchtext() {
    this.collabosList = this.savefilter;

    let tempCompany = this.collabosList.filter(
      (item) => {
        return (
          (item.name !== null && item.name.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1) ||
          (item.category !== null && item.category.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1) ||
          (item.expected_budget !== null && item.expected_budget.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)
        );
      }

    );
    this.collabosList = tempCompany;
    this.assigndynamicarray(tempCompany)
    // if(this.searchText==""){
    //   this.GetCollabos();
    //   this.assigndynamicarray(this.collabosList)
    // }
    if(this.searchText !== ""){
      this.collabosListDetails = tempCompany;
      this.setPage(1);
  }else{
      this.collabosListDetails = this.savefilter;      
      this.assigndynamicarray(this.collabosList)

      this.setPage(1);
  }

  }
  Back() {
    this.view = false;
  }
  viewDetails(c) {

    this.collabodetails = c;
    this.view = true;
    this.tabtype = 1;
    this.url = this.loginService.imageURL;
    this.collabobids = this.tempProposalBids.filter(x => x.collaboid == c.id);

    for (var i = 0; i < this.collabobids.length; i++) {
      let image = this.usersList.filter(x => x.id == this.collabobids[i].userid);

      if (image.length > 0) {
        if (image[0].Profile !== null) {
          //  this.url="http://localhost:25396/"; 
          this.url = this.loginService.imageURL;

        }
        else {
          this.url = "";
          image[0].Profile = '../../assets/images/user.png';

        }
        this.image = image[0].Profile;

        this.tempbids.push({
          name: this.collabobids[i].user_name,
          rate: this.collabobids[i].amount,
          proposal: this.collabobids[i].description,
          image: (this.url + this.image)
        })
      }
    }

    this.initiatordetails = this.usersList.filter(x => x.id == c.userid);

    let collabocountlist = this.collabosList.filter(x => x.userid == c.userid);

    this.opencollabos = collabocountlist.filter(x => x.status == 1)
    this.opencount = this.opencollabos.length;
    this.count = collabocountlist.length;

  }

  changeTab(tab) {
    this.tabtype = tab;

  }
  selectRow(id,e){
    if(e.target.checked){
     this.selectedCollabosListid.push(e.target.id)
    }
    else{
     var index = this.selectedCollabosListid.indexOf(e.target.id);
    this.selectedCollabosListid.splice(index,1)
    }
  }
  DeleteSelected(){
   if(this.selectedCollabosListid.length==0){
     return;
   }
   else{
     event.stopPropagation();
     Swal.fire({
       title: 'Are you sure?',
       text: 'You want to delete the selected rows' ,///
       icon: 'warning',
       showCancelButton: true,
       confirmButtonText: 'Yes',
       cancelButtonText: 'No'
     }).then((result) => {
       if (result.value) {
         this.deleterows(this.selectedCollabosListid);//
       } else if (result.dismiss === Swal.DismissReason.cancel) {
   
       }
     })
   }
  }
  deleterows(list){
 for(var i=0;i<list.length;i++){
   this.delete(list[i],'d');
   this.selectedCollabosListid=[];
 }
  }
  deletecollabos(row, isactive, text) {

    event.stopPropagation();
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to ' + text + ' this collabo:' + row.pagename,///
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.delete(row.id, isactive);//
      } else if (result.dismiss === Swal.DismissReason.cancel) {

      }
    })

  }

  delete(ID, isactive) {

    this.loginService.DeleteCollabos(ID, isactive).subscribe(data => {

      if (isactive == 'd') {
        this.loginService.showSuccess("Deleted Successfully", "");

      }
      else if (isactive == 'y') {
        this.loginService.showSuccess("Activated Successfully", "");

      }
      else {
        this.loginService.showSuccess("Deactivated Successfully", "");

      }
     
      this.GetCollabos();
      setTimeout(() => {
        this.message = "";
      }, 1000);
     
    })
  }




}
